import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import { FaImages } from 'react-icons/fa';
import { MdOutlineToys, MdContacts } from 'react-icons/md';
import { RiOrderPlayLine } from 'react-icons/ri';
import { TbUserSquare } from 'react-icons/tb';
import MonthSalesChart from 'common/chart/MonthSalesChart';





function Home() {
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.contactus);

  const salesDataINR = [
    1250000, 1575000, 2310000, 1980000, 2740000, 3200000,
    3450000, 3100000, 2900000, 3600000, 4100000, 5050000
  ];

  const { table_counts } = Data.data;
  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  return (
    <>
      <div className="container-fluid px-lg-5 mt-5">
        <div className="d-sm-flex align-items-center justify-content-between mb-4 mainheadig">
          <h1 className="h3 mb-0 text-white">Dashboard</h1>
        </div>
        <div className=" stat-row  mt-5">
          {/* Banner */}
          <div className="stat-col">
            <div className="stat-card shadow h-100">
              <div className="stat-header">
                <div className="icon-square bg-warning text-white">
                  <FaImages size={26} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Total Banner</div>
                  <div className="stat-count">{table_counts?.banner}</div>
                </div>
              </div>
              <div className="stat-footer"># overall</div>
            </div>
          </div>

          {/* Product */}
          <div className="stat-col">
            <div className="stat-card shadow h-100">
              <div className="stat-header">
                <div className="icon-square bg-primary text-white">
                  <MdOutlineToys size={26} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Total Product</div>
                  <div className="stat-count">{table_counts?.product}</div>
                </div>
              </div>
              <div className="stat-footer"># overall</div>
            </div>
          </div>

          {/* Orders */}
          <div className="stat-col">
            <div className="stat-card shadow h-100">
              <div className="stat-header">
                <div className="icon-square bg-success text-white">
                  <RiOrderPlayLine size={26} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Total Orders</div>
                  <div className="stat-count">{table_counts?.order}</div>
                </div>
              </div>
              <div className="stat-footer"># overall</div>
            </div>
          </div>

          {/* Users */}
          <div className="stat-col">
            <div className="stat-card shadow h-100">
              <div className="stat-header">
                <div className="icon-square bg-info text-white">
                  <TbUserSquare size={26} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Total Users</div>
                  <div className="stat-count">{table_counts?.customer}</div>
                </div>
              </div>
              <div className="stat-footer"># overall</div>
            </div>
          </div>

          {/* Contact Us */}
          <div className="stat-col">
            <div className="stat-card shadow h-100">
              <div className="stat-header">
                <div className="icon-square bg-danger text-white">
                  <MdContacts size={26} />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Total Contact Us</div>
                  <div className="stat-count">{table_counts?.contactus}</div>
                </div>
              </div>
              <div className="stat-footer"># overall</div>
            </div>
          </div>
        </div>


        <h3 className="my-5 heading-sales">Sales Overview</h3>

        <MonthSalesChart
          title="FY 2025 Month-wise Sales (₹)"
          data={salesDataINR}
          type="column"   // try "line" too
          height={440}
        />
      </div>
    </>
  );
}

export default Home;
